Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.ShowQuantityOptionView extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/charts/show_quantity_option']
  tagName: 'li'

  events:
    'click': '_toggleShowQuantity'

  initialize: ({isShowingTopTen}) ->
    @displayText = if isShowingTopTen then @_showAllResults() else @_showTopTen()
    @toggleEventName = 'chart:toggleShowQuantity'

  render: ->
    @$el.html @template
      displayText: @displayText
    @

  getToggleMethod: (chartView) ->
    chartView.toggleShowQuantity

  _toggleShowQuantity: ->
    @_toggleText()
    @trigger(@toggleEventName)

  _toggleText: ->
    @displayText = if @displayText == @_showTopTen() then @_showAllResults() else @_showTopTen()
    @render()

  _showAllResults: ->
    I18n.t('customer_visual_mode.charts.show_all_results')

  _showTopTen: ->
    I18n.t('customer_visual_mode.charts.show_top_ten')
